import { InjectionToken } from '@angular/core';

export const HOME_LINK_ENABLED = new InjectionToken<boolean>('shrd-uic.homeLinkEnabled', {
  providedIn: 'root',
  factory: () => true
});
